// Abastecimentos de cada desconto da página (GET /discount-usage, uma consulta só). Nunca trava a lista: enquanto
// não chega, ou se falhar, o cartão simplesmente não mostra a linha.
import { useMemo } from 'react';
import { useDataProvider } from 'react-admin';
import { useQuery } from '@tanstack/react-query';
import { DiscountUsage, toUsageMap } from './discountUsage';

/** O backend aceita até 50 ids por consulta (a maior página da lista é de 50). */
const MAX_IDS = 50;
const EMPTY = new Map<string, DiscountUsage>();

export const useDiscountUsage = (records: any[] | undefined, chainId: string | undefined): Map<string, DiscountUsage> => {
    const dataProvider = useDataProvider();
    const ids = useMemo(() => (records || []).map(record => String(record.id)).filter(Boolean).slice(0, MAX_IDS), [records]);
    const query = useQuery({
        queryKey: ['discount-usage', chainId, ids.join(',')],
        enabled: Boolean(chainId) && ids.length > 0,
        staleTime: 60 * 1000,
        retry: false,
        queryFn: async () => toUsageMap(await dataProvider.getList('discount-usage', {
            pagination: { page: 1, perPage: MAX_IDS },
            sort: { field: 'id', order: 'ASC' },
            filter: { ids },
        })),
    });
    return query.data ?? EMPTY;
};
